export const SET_WALL = 'SET_WALL'
export const SET_WALLMESSAGES = 'SET_WALLMESSAGES'
export const SET_WALLMESSAGE = 'SET_WALLMESSAGE'
export const RESET_WALLMESSAGES = 'RESET_WALLMESSAGES'
export const RESET_WALLMESSAGE = 'RESET_WALLMESSAGE'
export const SET_WALLMESSAGE_DATA = 'SET_WALLMESSAGE_DATA'
export const SET_ALLREAD = 'SET_ALLREAD'
export const SET_READCOUNT = 'SET_READCOUNT'
export const SET_MERGETAGS = 'SET_MERGETAGS'
export const SET_WORKINGTEXT = 'SET_WORKINGTEXT'

export const SET_MESSAGES = 'SET_MESSAGES'
export const SET_MESSAGE = 'SET_MESSAGE'
export const RESET_MESSAGE = 'RESET_MESSAGE'
export const SET_MESSAGE_DATA = 'SET_MESSAGE_DATA'
